export default [
  {
    path: "audit",
    component: () => import("@/pages/DPOPages/AuditTrailListPage"),
  },
];
